module.exports = __webpack_public_path__ + "static/media/alto.eceac48b.jpg";